<template>
   <section class="purchase_title">
       {{titlename}}
       <span v-if="subname"><router-link :to="sublink" @click="goClick" class="subtitle">{{subname}}</router-link></span>
   </section>
</template>

<script>
export default {
  name: 'PurchaseTitle',
  componentName: 'PurchaseTitle',
  props: {
    titlename: String,
    subname: '',
    sublink: ''
  },
  methods: {
    goClick () {
      this.omgTrack('es_chuxingquan_xieyi_edit_ck', '出行券模块点击编辑')
    }
  }
}
</script>

<style lang="stylus">
   .purchase_title{
       height: 50px
       background-color : #F3F4F5
       color: #333
       font-size: 16px
       line-height 50px
       margin-right: 20px;
        padding-left: 20px;
        margin-bottom: 40px;
        margin-top: 40px;
   }
   .subtitle{
      color:#3468FF;
      font-size: 14px;
      margin-left: 30px;
      text-decoration: none
   }
</style>
